// hooks/useGetRoles.js
import { useQuery } from '@tanstack/react-query';
import { getAllRoles } from '../../api/apiRoles';
import i18next from 'i18next';

export function useGetRoles(page = 1, perPage = 15, filters = {}) {
  const {
    isLoading,
    data,
    error
  } = useQuery({
    queryKey: ['roles', page, perPage, filters, i18next.language],
    queryFn: () => getAllRoles(page, perPage, filters),
    retry: false,
    keepPreviousData: true,
  });

  const roles = data?.data?.items || [];
  const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

  return { isLoading, error, roles, meta };
}
